import type { Components, Theme } from "@mui/material/styles";

export const MuiTable: Components<Theme>["MuiTable"] = {
  styleOverrides: {
    root: {
      position: "sticky",
    },
  },
};
